module.exports = __webpack_public_path__ + "static/media/square-full.b0282020.svg";